import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';

const RISK_LABEL_CRITICAL = 'Critical';
const RISK_LABEL_HIGH = 'High';
const RISK_LABEL_MEDIUM = 'Medium';
const RISK_LABEL_LOW = 'Low';
const RISK_LABEL_UNKNOWN = 'N/A';

const RISK_CRITICAL = 'critical';
const RISK_HIGH = 'high';
const RISK_MED = 'medium';
const RISK_LOW = 'low';
const RISK_UNKNOWN = 'unknown';
@Component({
  selector: 'risk-heat-meter',
  templateUrl: './risk-heat-meter.html',
  styleUrls: ['./risk-heat-meter.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiskHeatMeterComponent {
  @Input() risk: string = '';

  @Input() version = 'v1';

  @Output() interact: EventEmitter<Event> = new EventEmitter<Event>();

  get riskNormalized(): string {
    if (!this.risk || typeof this.risk !== 'string') return RISK_UNKNOWN;

    let r = this.risk.toLowerCase();

    if (r === 'critical' || r === 'c') {
      return RISK_CRITICAL;
    }

    if (r === 'high' || r === 'h') {
      return RISK_HIGH;
    }

    if (r === 'medium' || r === 'med' || r === 'm') {
      return RISK_MED;
    }

    if (r === 'low' || r === 'l') {
      return RISK_LOW;
    }

    return RISK_UNKNOWN;
  }

  get riskLabel(): string {
    if (!this.risk || typeof this.risk !== 'string') return RISK_LABEL_UNKNOWN;

    let r = this.risk.toLowerCase();

    if (r === 'critical' || r === 'c') {
      return RISK_LABEL_CRITICAL;
    }

    if (r === 'high' || r === 'h') {
      return RISK_LABEL_HIGH;
    }

    if (r === 'medium' || r === 'med' || r === 'm') {
      return RISK_LABEL_MEDIUM;
    }

    if (r === 'low' || r === 'l') {
      return RISK_LABEL_LOW;
    }

    return RISK_LABEL_UNKNOWN;
  }

  constructor() {}

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    this.interact.emit(event);
  }
}
